import { lazy, Suspense } from "react";
import { Nav, ScrollProgress } from "./components/chrome";
import { Hero } from "./components/sections/Hero";

// Above-the-fold (Nav + Hero) ships in the initial bundle; everything below the
// fold is code-split so first paint / LCP isn't blocked by the whole page's JS.
const named = <T extends string>(p: Promise<Record<T, React.ComponentType>>, k: T) =>
  p.then((m) => ({ default: m[k] }));

const Problem = lazy(() => named(import("./components/sections/Problem"), "Problem"));
const Solution = lazy(() => named(import("./components/sections/Solution"), "Solution"));
const StickyProduct = lazy(() => named(import("./components/sections/StickyProduct"), "StickyProduct"));
const Framework = lazy(() => named(import("./components/sections/Framework"), "Framework"));
const Dashboard = lazy(() => named(import("./components/sections/Dashboard"), "Dashboard"));
const VideoEvidence = lazy(() => named(import("./components/sections/VideoEvidence"), "VideoEvidence"));
const CoachVerification = lazy(() => named(import("./components/sections/CoachVerification"), "CoachVerification"));
const MoreFeatures = lazy(() => named(import("./components/sections/MoreFeatures"), "MoreFeatures"));
const Velocity = lazy(() => named(import("./components/sections/Velocity"), "Velocity"));
const ShareRecord = lazy(() => named(import("./components/sections/ShareRecord"), "ShareRecord"));
const Market = lazy(() => named(import("./components/sections/Market"), "Market"));
const FinalCTA = lazy(() => named(import("./components/sections/FinalCTA"), "FinalCTA"));

export default function App() {
  return (
    <>
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <div className="relative">
            <Problem />
            <Solution />
            <StickyProduct />
            <Framework />
            <Dashboard />
            <VideoEvidence />
            <CoachVerification />
            <MoreFeatures />
            <Velocity />
            <ShareRecord />
            <Market />
            <FinalCTA />
          </div>
        </Suspense>
      </main>
    </>
  );
}
